import { createFileRoute } from "@tanstack/react-router";
import { HariHubPage } from "@/components/pages/HariHubPage";
import { HARI_PENTING } from "@/data/hari-penting";
import { MONTH_NAMES_ID } from "@/lib/calendar/dates";

export const Route = createFileRoute("/hari/")({
  head: () => {
    const ld = [
      {
        "@context": "https://schema.org",
        "@type": "CollectionPage",
        name: "Daftar Hari Penting Nasional & Internasional Indonesia",
        description:
          "Daftar lengkap hari peringatan nasional dan internasional di Indonesia: Hari Kartini, Hari Ibu, Hari Guru, Hari Buruh, dan lainnya.",
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: [
          { "@type": "ListItem", position: 1, name: "Beranda", item: "https://hari.co.id/" },
          { "@type": "ListItem", position: 2, name: "Hari Penting", item: "https://hari.co.id/hari/" },
        ],
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        itemListElement: HARI_PENTING.map((h, i) => {
          const [mm, dd] = h.monthDay.split("-").map((n) => parseInt(n, 10));
          return {
            "@type": "ListItem",
            position: i + 1,
            url: `/hari/${h.slug}`,
            name: `${h.name}, ${dd} ${MONTH_NAMES_ID[mm - 1]}`,
          };
        }),
      },
    ];
    return {
      meta: [
        { title: "Hari Penting Nasional & Internasional Indonesia: Daftar Lengkap" },
        {
          name: "description",
          content:
            "Daftar lengkap hari peringatan di Indonesia: Hari Kartini, Hari Ibu, Hari Guru, Hari Buruh, Hari Batik, dan lainnya. Cek tanggal, sejarah, dan maknanya.",
        },
        { property: "og:title", content: "Hari Penting Nasional & Internasional Indonesia" },
        {
          property: "og:description",
          content:
            "Cek tanggal hari peringatan di Indonesia lengkap dengan sejarah dan tradisinya.",
        },
      ],
      links: [{ rel: "canonical", href: "https://hari.co.id/hari/" }],
      scripts: ld.map((obj) => ({
        type: "application/ld+json",
        children: JSON.stringify(obj),
      })),
    };
  },
  component: HariHubPage,
});